import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import es from 'vuetify/src/locale/es';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'md',
    values: {
      logo_jira: 'M11.714 11.6753H4C4.00026 12.1328 4.09074 12.5857 4.26626 13.0081C4.44178 13.4305 4.6989 13.8142 5.02288 14.1371C5.34687 14.4601 5.73137 14.7159 6.15437 14.8901C6.57737 15.0642 7.03056 15.1532 7.488 15.152H8.908V16.5233C8.908 17.4452 9.27411 18.3293 9.92582 18.9812C10.5775 19.6332 11.4615 19.9996 12.3833 20V12.3453C12.3833 12.1676 12.3127 11.9972 12.1871 11.8716C12.0614 11.7459 11.891 11.6753 11.7133 11.6753H11.714ZM15.5293 7.838H7.824C7.82418 8.75995 8.19055 9.64409 8.84253 10.2959C9.49451 10.9478 10.3787 11.314 11.3007 11.314H12.72V12.686C12.7207 13.6078 13.0872 14.4916 13.7391 15.1434C14.391 15.7951 15.2749 16.1615 16.1967 16.162V8.50533C16.1967 8.32835 16.1264 8.15861 16.0012 8.03346C15.8761 7.90831 15.7063 7.838 15.5293 7.838ZM19.342 4H11.6367C11.6367 4.92207 12.003 5.80637 12.655 6.45837C13.307 7.11038 14.1913 7.47667 15.1133 7.47667H16.5327V8.848C16.5334 9.76799 16.8987 10.6502 17.5486 11.3014C18.1985 11.9525 19.08 12.3195 20 12.322V4.67C20.0007 4.49416 19.932 4.32514 19.8088 4.19968C19.6856 4.07422 19.5178 4.00246 19.342 4Z'
    }
  },
  lang: {
    locales: { es },
    current: 'es',
  },
  theme: {
    themes: {
      light: { // Replicado en variables.scss 
        primary: '#57ACCE',
        secondary: '#37474F',
        accent: '#E48A27',
        error: '#F15757',
        warning: '#FFB926',
        info: '#9B9B9B',
        success: '#67FFBD',
        light: '#F5F9FA'
      }
    }
  }
});
